export default __webpack_public_path__ + "static/web-site-top-94d329d1c26a825b357a15e8048d4db3.jpg";